export default __webpack_public_path__ + "static/media/new-shape-active.826a968d.svg";